/** Persistência e helpers de filtros NFS-e (evita limpar datas ao navegar). */

export function toIsoDateLocal(d) {
  if (!d) return undefined;
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return undefined;
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function loadFiltrosPersistidos(storageKey, emptyFactory) {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return emptyFactory();
    const p = JSON.parse(raw);
    const base = emptyFactory();
    return {
      ...base,
      ...p,
      dataInicio: p.dataInicio ? new Date(p.dataInicio) : base.dataInicio,
      dataFim: p.dataFim ? new Date(p.dataFim) : base.dataFim,
    };
  } catch {
    return emptyFactory();
  }
}

export function saveFiltrosPersistidos(storageKey, filtros) {
  try {
    const payload = {
      ...filtros,
      dataInicio: filtros.dataInicio ? toIsoDateLocal(filtros.dataInicio) : null,
      dataFim: filtros.dataFim ? toIsoDateLocal(filtros.dataFim) : null,
    };
    sessionStorage.setItem(storageKey, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function filtrosTemDatas(filtros) {
  return !!(filtros?.dataInicio && filtros?.dataFim);
}

/** Monta query string de export ZIP por filtros (sem ids). */
export function buildExportFilterParams(filtros, map = {}) {
  const params = { formato: 'zip' };
  const f = filtros || {};
  if (f.dataInicio) params.dataInicio = toIsoDateLocal(f.dataInicio);
  if (f.dataFim) params.dataFim = toIsoDateLocal(f.dataFim);
  if (f.filialId != null && f.filialId !== '') params.filialId = f.filialId;
  if (f.status) params.status = f.status;
  if (f.numero) params.numero = f.numero;
  if (f.chave) params.chave = f.chave;
  if (f.serie) params.serie = f.serie;
  if (f.busca) params.busca = f.busca;
  if (f.prestador) params.prestador = f.prestador;
  if (f.codigoItemServico) params.codigoItemServico = f.codigoItemServico;
  // agente: emitidas = agenteId; tomadas = prestadorAgenteId
  if (map.agenteIdKey && f[map.agenteIdKey] != null) {
    params[map.agenteIdParam || map.agenteIdKey] = f[map.agenteIdKey];
  }
  return params;
}
